<template>
	<page>
		<module title="积分抽奖配置">
			<div class="flex-between">
				<div v-show="step == 1">
					<c-form ref="baseForm" title="基础信息">
						<c-form-item type="datetime" date-type="datetime" label="抽奖活动时间" start-name="start_date"
							end-name="end_date" required></c-form-item>
						<c-form-item label="每次所需积分" name="lottery_points" input-unit="分" type="number" decimal="0"
							:limit="[0,99999]" word="注：每次参与抽奖，消耗X积分；填0则表示无需消耗积分" required></c-form-item>
						<c-form-item type="radio" label="抽奖次数类型" v-model="lotteryLimitType"
							:options="lotteryLimitTypeOptions" name="lottery_limit_type" :word="lotteryLimitTypeTitle"
							required>
						</c-form-item>
						<c-form-item v-show="lotteryLimitType!=-1" label="抽奖次数" name="lottery_limit" input-unit="次"
							type="number" decimal="0" :limit="[1,9999]" word="注：最多参加抽奖的次数" required></c-form-item>
						<c-form-item type="radio" label="是否限制中奖次数" v-model="winCountType" :options="winCountOptions"
							name="win_count_type" required>
						</c-form-item>
						<c-form-item v-show="winCountType == 1" label="中奖次数上限" type="number" decimal="0" :limit="[1,9999]"
							name="win_count_number" input-unit="次" word="注：每个账号最多中奖X次，后续将不再中奖" required>
						</c-form-item>
						<!--          <c-form-item type="radio" label="额外抽奖机会" v-model="lotteryChanceType" :options="lotteryChanceOptions" name="lottery_chance_type"
					:word="lotteryChanceTitle" required>
			  </c-form-item>-->
					</c-form>
					
					<c-form ref="probabilityForm" title="页面设置">
						<c-form-item v-show="false" type="radio" label="抽奖模式" v-model="lotteryMethod" :options="lotteryMethodOptions"
							name="lottery_method" required>
						</c-form-item>
						<c-form-item v-model="bgImg" type="image" label="Banner图" name="banner_img_url" required>
							<span slot="word">
								展示在抽奖页顶部作为Banner图片，建议尺寸：750X520
							</span>
						</c-form-item>
						<c-form-item v-model="bgColor" type="color" label="背景颜色" name="background_color" required>
							<span slot="word">
								整个抽奖页面的背景颜色
							</span>
						</c-form-item>
						<c-form-item type="textarea" label="抽奖规则描述" name="lottery_rules">
						</c-form-item>
					</c-form>
				</div>
				
				<div v-show="step == 2">
					<c-form title="奖品设置">
						<div class="area">
							<m-operate>
								<c-button color="black" hollow @click="$refs.productSelector.open()">添加商品</c-button>
								<c-button color="black" hollow @click="$refs.couponSelector.open()">添加优惠券</c-button>
								<c-button color="black" hollow @click="editGiftPoints()">添加积分</c-button>
							</m-operate>
							<c-table v-model="lotteryAwardList" ref="gift" height="auto" :paging="false" border>
								<c-table-column label="奖品类型" width="60">
									<template v-slot="{data}">
										<span v-if="data.award_type == 1" style="color: blue">商品</span>
										<span v-if="data.award_type == 2" style="color: brown">积分</span>
										<span v-if="data.award_type == 3" style="color: darkgreen">优惠券</span>
									</template>
								</c-table-column>

								<c-table-column label="奖品信息" width="350">
									<template v-slot="{data}">
										<span v-if="data.award_type == 1">
											<span>{{data.product_name}} / {{data.product_sku_spec}}</span>
										</span>
										<span v-if="data.award_type == 2">
											<span>奖励 <a style="color:blue;">&nbsp;{{data.count}}&nbsp;</a> 积分</span>
										</span>
										<span v-if="data.award_type == 3">
											<span>
												【{{data.coupon_name}}】{{data.coupon_detail}}
												<span v-if="data.award_config_map" style="color: darkgray;font-size:12px">
                                                    (自中奖之日起，{{data.award_config_map.effective_days}}天后过期)
                                                </span>
												<span v-else style="color: darkgray;font-size:12px">
                                                    (自中奖之日起，90天后过期)
                                                </span>
											</span>
										</span>
									</template>
								</c-table-column>

								<c-table-column type="button" fixed="right" label="操作" width="100">
									<template v-slot="row">
										<c-table-button v-if="row.data.id > 0 && row.data.award_type == 3" @click="editAwardConfig(row)">配置</c-table-button>
										<c-table-button v-if="row.data.id > 0" @click="removeLotteryAward(row)">删除</c-table-button>
									</template>
								</c-table-column>
							</c-table>
						</div>
					</c-form>
					
					<c-form title="奖项设置">
						<div class="area">
							<p style="margin-bottom: 10px; font-size: 13px; color: #f55;">中奖概率可填0，表示不会中奖</p>
							<!-- <m-operate>
								<c-button color="black" hollow @click="addAwardItem()">添加奖项</c-button>
							</m-operate> -->
							<c-table v-model="awardItemList" ref="giftItem" height="auto" :paging="false" border>
								<c-table-column label="序号" width="40" name="sort_id"></c-table-column>
					
								<c-table-column label="奖项名称" name="award_name" width="100">
									<template v-slot="{data}">
										<c-input v-model="data.award_name" @blur="updatePreview"></c-input>
									</template>
								</c-table-column>
					
								<c-table-column label="奖品" width="200">
									<template v-slot="{data}">
										<c-select v-model="data.award_id" width="100"
											:options="lotteryAwardSelcter"></c-select>
									</template>
								</c-table-column>
					
								<c-table-column label="图标" name="award_img_url" width="66">
									<template v-slot="{data}">
										<c-media v-model="data.award_img_url" type="image" @change="updatePreview"></c-media>
									</template>
								</c-table-column>
					
								<c-table-column label="单项中奖概率" name="award_img_url" width="110">
									<template v-slot="{data}">
										<div class="flex-center">
											<span>{{data.probability_count == '0' ? '' : '1 / '}}</span>
											<c-input v-model="data.probability_count" type="number" width="80" decimal="0" @change="countChangeHadler()"
												:limit="[0,99999999]" style="margin-left: .5em;"></c-input>
										</div>
									</template>
								</c-table-column>
								
								<c-table-column label="全局中奖概率" name="award_img_url" width="120">
									<template v-slot="{data}">
										<span v-if="data.actual_probability == 0" style="color:#999">{{data.actual_probability}}%</span>
										<span v-else-if="data.actual_probability > 10 && data.award_id != 0" style="color:red">{{data.actual_probability}}%</span>
										<span v-else="data.actual_probability == 0">{{data.actual_probability}}%</span>
									</template>
								</c-table-column>
					
								<c-table-column type="sort" label="排序" width="100" @sort="sortHandle"></c-table-column>
					
								<!-- <c-table-column type="button" fixed="right" label="操作" width="60">
									<template v-slot="row">
										<c-table-button @click="row.remove()">删除</c-table-button>
									</template>
								</c-table-column> -->
							</c-table>
						</div>
					</c-form>
					
					<!-- <c-form ref="unWinForm" title="未中奖设置">
						<c-form-item label="名称" name="un_win_title" type="input" maxlength="10"
							word="不填默认使用：谢谢参与"></c-form-item>
						<c-form-item label="未中奖图片" name="un_win_img_url" type="image" maxlength="50"
							word="该图片将在转盘中作为未中奖的项图片展示"></c-form-item>
					</c-form> -->
				</div>
				
				<div v-if="previewList.length" class="preview" :style="{'background': bgColor}">
					<img class="preview-banner" :src="bgImg"></img>
					<div class="preview-main" :style="{'background-image': `url(${oss('/lottery/main.png')})`}">
						<div class="preview-head flex-column flex-center">
							<p class="preview-title">恭喜您又可以抽奖啦！</p>
							<p class="preview-count">还有<span>N次</span>抽奖机会</p>
						</div>
						<div class="preview-list flex-wrap">
							<template v-for="(item, i) in previewList">
								<img v-if="i == 4" class="preview-btn" :src="oss('/lottery/btn.png')"></img>
								<div v-else :key="i" class="preview-item flex-column flex-center-cross" :style="{'background-image': `url(${oss('/lottery/item.png')})`}">
									<div class="preview-item-img flex-center">
										<img :src="item.award_img_url"></img>
									</div>
									<p>{{item.award_name}}</p>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
			
			<template slot="button">
				<c-button size="m" hollow v-show="step > 1" @click="preStep()">上一步</c-button>
				<c-button size="m" v-show="step < 2" @click="nextStep()">下一步</c-button>
				<c-button size="m" v-show="step == 2" @click="submitData()">提交数据</c-button>
			</template>
			
			<!--提示信息-->
			<c-dialog ref="tipDialog" title="抽奖中奖概率规则说明" width="610" height="500" button-name="知道了" :close-button="false"
				:cancel-button="false">
				<div>
					<div class="import-steps">
						<h4>独立概率模式</h4>
						<p>·多次抽奖互不影响，完全独立。</p>
						<p>·举例：奖项A的中奖概率为5%，则用户每次参与抽奖，获得奖项A的几率都是5%，不会因为A已经中过奖或者没中过奖二变化。</p>
					</div>
				</div>
			
				<div>
					<div class="import-steps">
						<h4>动态概率模式</h4>
						<p>·每次抽奖的中奖概率，会根据前一次是否已经中奖而变化。</p>
						<p>·举例：奖项A的中奖概率为5%，用户每次参与抽奖，如果未能中奖，则用户的中奖权重将会累计使用户下一次参与抽奖中奖几率升高，直至中奖后，权重清零。</p>
					</div>
				</div>
			</c-dialog>
			<c-dialog ref="giftPointsDialog" title="奖励积分信息" width="450" height="200" @resolve="reloadGiftPoints">
				<c-form ref="pointsForm">
					<c-form-item type="number" label="奖励积分" :limit="[0,99999]" required name="prize_points"
						v-model="prizePoints" decimal="0" input-unit="分" word="中奖后奖励的积分数量，填写0表示不奖励"></c-form-item>
				</c-form>
			</c-dialog>
			<c-dialog ref="awardConfigDialog" title="奖品配置" width="450" height="200" @resolve="submitAwardConfigForm">
				<c-form ref="awardConfigForm">
					<c-form-item type="number" label="优惠券有效期" :limit="[1,99999]"
                                 required name="effective_days" decimal="0" input-unit="天" word="自中奖之日开始，优惠券的有效期天数，超过该时间则优惠券过期，无法在使用"></c-form-item>
				</c-form>
			</c-dialog>
			<product-selector ref="productSelector" scene="lottery" sku multiple
				@resolve="selectHandle($event, 'product')"></product-selector>
			<coupon-selector ref="couponSelector" multiple @resolve="selectHandle($event, 'coupon')"></coupon-selector>
		</module>
	</page>
</template>

<script>
	import nodeList from '@/components/public/node_list.vue'
	import productInfo from '@/components/public/product_info.vue'
	import productSelector from '@/components/service/product_selector.vue'
	import couponSelector from '@/components/service/coupon_selector.vue'
	import {
		mapState
	} from 'vuex'

	export default {
		name: 'm_lottery_award_config',

		components: {
			nodeList,
			productInfo,
			productSelector,
			couponSelector
		},

		props: {
			orderNumber: String
		},

		data() {
			return {
				step: 1, //步骤
				winCountOptions: [{
						name: '无限制',
						value: '-1'
					},
					{
						name: '限制',
						value: '1'
					}
				],
				winCountType: -1, //中奖次数类型  -1 表示不限制中奖次数  1=中奖若干次之后就不再中奖
				lotteryLimitTypeOptions: [{
						name: '不做限制',
						value: '-1'
					},
					{
						name: '按天限制',
						value: '1'
					},
					{
						name: '按总数限制',
						value: '2'
					}
				],
				lotteryLimitType: 1, //中奖次数类型  -1 表示不限制中奖次数  1=中奖若干次之后就不再中奖
				lotteryChanceOptions: [{
						name: '无',
						value: '-1'
					},
					{
						name: '下单获得',
						value: '1'
					},
					{
						name: '',
						value: '2'
					}
				],
				lotteryChanceType: -1, //获取抽奖机会的方法
				probabilityTypeOptions: [{
						name: '独立概率模式',
						value: '1'
					},
					{
						name: '动态概率模式',
						value: '2'
					}
				],
				lotteryMethodOptions: [{
						name: '九宫格',
						value: '1'
					},
					{
						name: '转盘',
						value: '2'
					}
				],
				lotteryMethod: 1,
				probabilityType: 1, //中奖概率方式
				lotteryAwardList: [], //奖品列表
				lotteryAwardSelcter: [], //奖品下拉框
				awardItemList: [], //转盘奖项设置
				prizePoints: 0,
				bgImg: '',
				bgColor: '',
				previewList: [],
                awardProductData:null
			}
		},

		computed: {
			lotteryChanceTitle() {
				return {
					'-1': '不赠予额外的抽奖机会',
					'1': '每次下单获得1次抽奖机会。注：仅限普通下单，积分兑换类型订单无效，抽奖机会将在确认收货后赠予',
					'2': '商品或者页面，每分享一次获得一次抽奖机会'
				} [this.lotteryChanceType]
			},

			lotteryLimitTypeTitle() {
				return {
					'-1': '不做限制，可以参与任意多次的抽奖',
					'1': '按天限制，每个账号每天最多参与X次抽奖，每天0点刷新次数',
					'2': '按照参与总数限制，每个账号总共最多参与X次抽奖'
				} [this.lotteryLimitType]
			}
		},

		watch: {
			step() {
				this.$nextTick(() => {
					this.$refs.gift.resize();
					this.$refs.giftItem.resize();
				})
			}
		},

		mounted() {
			this.initLotteryAwardConfig();
			this.initLotteryAwardProduct();
		},

		methods: {
			//初始化转盘抽奖配置
			initLotteryAwardConfig() {
				//更新奖品数据
				this.request({
					url: '/lottery_award_config/list',
					data: {},
					success: data => {
						this.awardItemList = new Array(8).fill('').map((item, index) => {
							return data.award_item_list[index] || {
								sort_id: index + 1,
								title: '',
								award_id: -1,
								award_img_url: '',
								award_probability: 0
							}
						});
						var configJson = data.lottery_award_config;
						this.$nextTick(() => {
							if (this.$refs.baseForm) this.$refs.baseForm.set(configJson);
							if (this.$refs.unWinForm) this.$refs.unWinForm.set(configJson);
							if (this.$refs.probabilityForm) this.$refs.probabilityForm.set(configJson);

							this.winCountType = configJson.win_count_type;
							this.lotteryLimitType = configJson.lottery_limit_type;
							this.lotteryChanceType = configJson.lottery_chance_type;
							this.probabilityType = configJson.probability_type;
						})
						this.updatePreview();
					}
				});
			},
			//初始化抽奖商品列表
			initLotteryAwardProduct() {
				//更新奖品数据
				this.request({
					url: '/lottery_award_config/product/list',
					data: {},
					success: data => {
						this.lotteryAwardList = data;
						this.lotteryAwardSelcter = Array.from(data, item => {
							var name = '';
							if (item.award_type == 1) { //商品
								name = name + '【商品】';
								name = name + item.product_name + '/' + item.product_sku_spec;
							} else if (item.award_type == 2) { //积分
								name = name + '【积分】';
								name = name + item.count + "分";
							} else if (item.award_type == 3) { //优惠券
								name = name + '【优惠券】';
								name = name + item.coupon_name;
							}
							return {
								name: name,
								value: item.id
							}
						});
						this.lotteryAwardSelcter.unshift({
							name: '【未中奖】',
							value: 0
						})
					}
				});
			},
			//初始化抽奖配置
			addAwardItem() {
				this.$nextTick(() => {
					var length = this.awardItemList.length;
					this.awardItemList.push({
						sort_id: (length + 1),
						title: '',
						award_id: -1,
						award_img_url: '',
						award_probability: 0
					});
				})
			},
			/**
			 * 上一步，处理方法
			 * @param stop
			 */
			preStep() {
				this.step = this.step - 1;
			},
			/**
			 * 下一步，处理方法
			 * @param stop
			 */
			nextStep(stop) {
				if (this.step == 1) {
					//判断必填项
					var baseFormData = this.$refs.baseForm.serialize();
					if (!baseFormData.start_date || baseFormData.start_date == '') {
						this.$message({
							text: '请选择抽奖活动时间',
							icon: 'fail'
						});
						return;
					}
					if (!baseFormData.lottery_points || baseFormData.lottery_points == '' || parseInt(baseFormData
							.lottery_points) < 0) {
						this.$message({
							text: '请填写每次参与抽奖所需消耗的积分',
							icon: 'fail'
						});
						return;
					}
					if (!baseFormData.lottery_limit_type || baseFormData.lottery_limit_type == '') {
						this.$message({
							text: '请填选择抽奖次数类型',
							icon: 'fail'
						});
						return;
					}
					if (this.lotteryLimitType != -1 && (!baseFormData.lottery_limit || baseFormData.lottery_limit == '')) {
						this.$message({
							text: '请填写抽奖次数',
							icon: 'fail'
						});
						return;
					}
					if (this.winCountType != -1 && (!baseFormData.win_count_number || baseFormData.win_count_number ==
						'')) {
						this.$message({
							text: '请填写奖次数上限',
							icon: 'fail'
						});
						return;
					}
					this.step = 2;
				} else if (this.step == 2) {
					if (!this.lotteryAwardList || this.lotteryAwardList.length <= 0) {
						this.$message({
							text: '请添加中奖奖项信息',
							icon: 'fail'
						});
						return;
					}
					//判断必填项
					/*var unWinFormData = this.$refs.unWinForm.serialize();
					if (!unWinFormData.un_win_title || baseFormData.un_win_title == '') {
					  this.$message({
					    text: '请填写未中奖名称',
					    icon: 'fail'
					  });
					  return;
					}
					if (!unWinFormData.un_win_tips || baseFormData.un_win_tips == '') {
					  this.$message({
					    text: '请填写未中奖提示语',
					    icon: 'fail'
					  });
					  return;
					}*/
					this.step = 3;
				}
			},
			/**
			 * 选择商品、优惠券后的响应方法
			 * */
			selectHandle(data, type) {
				if (type == 'product') {
					//做去重处理
					data = data.filter(item => {
						return !this.lotteryAwardList.find(row => {
							return row.award_type == 1 && row.product_sku == item.product_sku;
						});
					});
					this.lotteryAwardList = (this.lotteryAwardList).concat(Array.from(data, item => {
						return {
							award_type: 1,
							count: 1,
							product_sku: item.product_sku,
							product_sku_spec: item.product_sku_spec,
							product_name: item.product_name,
							product_img_url: item.product_img_url
						}
					}));
				} else if (type == 'coupon') {
					//做去重处理
					data = data.filter(item => {
						return !this.lotteryAwardList.find(row => {
							return row.award_type == 3 && row.coupon_id == item.id;
						});
					});
					this.lotteryAwardList = (this.lotteryAwardList).concat(Array.from(data, item => {
						return {
							award_type: 3,
							count: 1,
							coupon_id: item.id,
							coupon_name: item.coupon_name,
							coupon_kinds: item.coupon_kinds,
							coupon_detail: item.detail
						}
					}));
				}
				//更新奖品数据
				this.request({
					url: '/lottery_award_config/product/add',
					data: {
						product_list: this.lotteryAwardList
					},
					success: data => {
						this.initLotteryAwardProduct();
					}
				});
			},
			//编辑积分信息
			editGiftPoints() {
				this.prizePoints = 0;
				this.$refs.giftPointsDialog.open();
			},
			//刷新奖励优积分信息
			reloadGiftPoints(stop) {
				stop();
				if (!this.prizePoints || this.prizePoints <= 0) {
					this.$message({
						icon: 'fail', // 图标（success：成功，fail：失败）
						text: '请输入奖励的积分信息'
					});
					return;
				}
				var product_list = [{
					award_type: 2,
					count: this.prizePoints
				}];
				this.request({
					url: '/lottery_award_config/product/add',
					data: {
						product_list: product_list
					},
					success: data => {
						this.initLotteryAwardProduct();
						this.$refs.giftPointsDialog.close();
					}
				});
			},

            //配置奖品其他配置
            submitAwardConfigForm(stop) {
                stop();
                this.$refs.awardConfigForm.submit({
                    url: '/lottery_award_config/product/edit',
                    rule: {
                        effective_days: [{
                            type: 'empty',
                            word: '请输入优惠券有效期',
                            skip: data => {
                                return this.awardProductData.award_type != 3;
                            }
                        }]
                    },
                    dataFormatter: data => {
                        var award_config = {};
                        award_config.effective_days = data.effective_days;
                        data.id = this.awardProductData.id;
                        data.award_config = JSON.stringify(award_config);;
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this._resolve(res);
                        this.$refs.awardConfigDialog.close();
                        this.awardProductData = null;
                    },
                });
            },
			//编辑奖品其他配置信息
            editAwardConfig(row) {
                this.awardProductData = row.data;
                this._resolve = data => {
                    row.update(data);
                };
                this.$refs.awardConfigForm.set(this.awardProductData.award_config_map||{});
                this.$refs.awardConfigDialog.open();
			},
			//删除奖品
			removeLotteryAward(row) {
				this.$confirm({
					text: '是否确实删除该奖品信息，删除后奖品将立即失效，请谨慎操作',
					buttonName: '确定删除',
					cancelButton: false,
					resolve: () => {
						this.request({
							url: '/lottery_award_config/product/remove',
							data: {
								id: row.data.id
							},
							success: data => {
								this.initLotteryAwardProduct();
							}
						});
					}
				});
			},
			//排序
			sortHandle(row, type, next) {
				let submitData = {};
				submitData.type = type;
				if (type == 'top' || type == 'bottom') {
					submitData.id = row.data.id;
				}
				if (type == 'up') {
					submitData.id1 = row.data.id;
					submitData.id2 = row.prev().data.id;
					submitData.type = "";
				}
				if (type == 'down') {
					submitData.id1 = row.data.id;
					submitData.id2 = row.next().data.id;
					submitData.type = "";
				}
				next();
			},
			//编辑中奖次数
			countChangeHadler(){
				//计算总转换概率
				let totalConvertProb = 0;
				this.awardItemList.forEach(item => {
					let temp_probability_count = 0;
					item.convert_prob = 0;
					if(parseFloat(item.probability_count||'0') != 0){
						item.convert_prob = 1/parseFloat(item.probability_count);
					}
					totalConvertProb = totalConvertProb + (item.convert_prob||0);
				});
				
				// 计算每个奖项全局中奖概率（用于显示）（已经乘以100）
				this.awardItemList.forEach(item => {
					item.actual_probability = parseFloat(((item.convert_prob/totalConvertProb)*100).toFixed(8));
				});
			},
			//提交数据
			submitData() {
				//1、奖项数据必须存在
				if (this.lotteryMethod == 1 && (!this.awardItemList || this.awardItemList.length != 8)) {
					this.$message({
						text: '【九宫格】模式下，中奖奖项数量必须是8项',
						icon: 'fail'
					});
					return;
				}
				if (this.lotteryMethod == 2 && (!this.awardItemList || this.awardItemList.length == 0)) {
					this.$message({
						text: '请至少添加一项奖项',
						icon: 'fail'
					});
					return;
				}
				//2、奖项数据非空
				for (let i = 0, l = this.awardItemList.length; i < l; i++) {
					var obj = this.awardItemList[i];
					if (!obj.award_name || obj.award_id == -1 ||
						!obj.award_img_url ||
						obj.probability_count === ''
					) {
						this.$message({
							text: '请完善奖项配置数据',
							icon: 'fail'
						});
						return;
					}
				}
				//3、提交数据
				let data0 = this.$refs.baseForm ? this.$refs.baseForm.get() : {};
				let data1 = this.$refs.unWinForm ? this.$refs.unWinForm.get() : {};
				let data2 = this.$refs.probabilityForm ? this.$refs.probabilityForm.get() : {};
				let submitData = Object.assign({}, data0, data1, data2);
				this.request({
					url: '/lottery_award_config/edit',
					data: {
						lottery_award_config: JSON.stringify(submitData),
						award_item_list: this.awardItemList
					},
					dataFormatter: data => {
						data.lottery_chance_type = this.lotteryChanceType;
						data.probability_type = this.probabilityType;
						return data;
					},
					success: data => {
						this.$message({
							text: '抽奖配置信息提交成功',
							icon: 'success'
						});
					}
				});
			},
			
			updatePreview() {
				this.previewList = [0, 1, 2, 7, -1, 3, 6, 5, 4].map(item => {
					return this.awardItemList[item];
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme'
	
	.area {
		width: 800px;
		padding: 10px;
		margin-top: -20px;
		background: #F7F7F7;
		
		>>> .m-operate {
			padding: 0;
			background: none;
		}
		
		>>> .c-media-item {
			width: 50px;
			height: 50px;
		}
	}
	
	.preview {
		align-self: flex-start;
		position: sticky;
		top: 80px;
		width: 375px;
		min-width: 375px;
		border-radius: 12px;
		padding-bottom: 10px;
		margin-right: 20px;
		overflow: hidden;
		
		&-banner {
			width: 100%;
			height: auto;
		}
		
		&-main {
			padding-bottom: 30px;
			background-size: 100% 100%;
		}
		
		&-head {
			padding: 50px 0 18px;
		}
		
		&-title {
			font-size: 18px;
			color: #fff;
		}
		
		&-count {
			margin-top: 6px;
			font-size: 24px;
			color: #fff;
			
			span {
				color: #FCE701;
			}
		}
		
		&-list {
			gap: 6px;
			width: 282px;
			margin: 0 auto;
		}
		
		&-btn {
			width: 90px;
			height: 90px;
			background-size: 100% 100%;
		}
		
		&-item {
			width: 90px;
			height: 90px;
			font-size: 12px;
			color: #E74435;
			background-size: 100% 100%;
			
			&-img {
				width: 60px;
				height: 45px;
				margin: 10px 0 4px;
			}
		}
	}
</style>